import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/lead-magnet-7791403_1280.webp")